"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../BaseComponent");
var MySpace = /** @class */ (function (_super) {
    __extends(MySpace, _super);
    function MySpace($view) {
        var _this = _super.call(this, $view) || this;
        _this.toggler = $(".my-space-menu-toggler");
        _this.bind();
        return _this;
    }
    //TODO surement un bug ici avec le this.view undefined
    MySpace.prototype.bind = function () {
        var _this = this;
        $(this.toggler).each(function (i, el) {
            $(el).on('click', function (e) {
                e.preventDefault();
                $(_this.$view).toggleClass('open');
            });
        });
    };
    return MySpace;
}(BaseComponent_1.default));
exports.default = MySpace;
